import { NgClass, NgStyle } from '@angular/common';
import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { PrimeTemplate } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { BaseComponent } from '../../../../content/components/base/base.component';
import { DialogTableDataRow } from '../../../../content/interfaces/dialog-table-data-row';
import { OrganisationData } from '../../../../content/interfaces/organisation/organisation-data';
import { UserData } from '../../../../content/interfaces/user-data';
import { I18nService } from '../../../../core/services/i18n.service';
import { LayoutService } from '../../../../layout/services/layout.service';
import { ProfileCustomerToTableDataMapperService } from '../../../mapper/profile-customer-to-table-data-mapper.service';

@Component({
  selector: 'sps-profile-customer',
  imports: [
    PrimeTemplate,
    TableModule,
    NgClass,
    NgStyle
  ],
  templateUrl: './sps-profile-customer.component.html'
})
export class SpsProfileCustomerComponent extends BaseComponent implements OnInit {

  @Input() userData: UserData;
  @Input() organisationData: OrganisationData;
  @Input() titleColumnWidth: string = 'auto';
  @Input() valueColumnWidth: string = 'auto';

  @Output() onDataChanged = new EventEmitter<boolean>();

  layoutService = inject(LayoutService);
  i18n = inject(I18nService);
  customerOrganisationMapper = inject(ProfileCustomerToTableDataMapperService);

  /**
   * Data for Customer-Data table
   */
  tableDataCustomer: DialogTableDataRow[] = [];

  ngOnInit() {
    this.mapCustomerTableData();
  }

  private mapCustomerTableData() {
    this.tableDataCustomer = this.customerOrganisationMapper.map(this.userData, this.organisationData);
  }
}
